import { createSelector } from 'reselect';
import { RootState } from 'data'; // adjust import path
import { PaginationState } from './slice';

// Base selector
const paginationSelector = (state: RootState) => state.pagination;

/**
 * Helper function to create memoized selectors for different fields
 */
const createPaginationSelector = <T extends keyof PaginationState>(field: T) =>
  createSelector(
    [paginationSelector],
    (paginationState): PaginationState[T] => paginationState[field]
  );

// Individual selectors
export const selectPage = createPaginationSelector('page');
export const selectRowsPerPage = createPaginationSelector('rowsPerPage');

/**
 * Derived selector → useful for slicing data arrays
 */
export const selectPaginationRange = createSelector(
  [selectPage, selectRowsPerPage],
  (page, rowsPerPage) => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return { startIndex, endIndex };
  }
);
